// src/app/app.routes.ts
import { Routes } from "@angular/router";
import { BookingComponent } from "./booking/calendar/booking.component";
import { AuthGuard } from "./guards/auth.guard";
import { LoginComponent } from "./pages/login/login.component";
import { RegisterComponent } from "./pages/register/register.component";
import { FavoritesComponent } from "./favorites/favorites.component";
import { AircraftListComponent } from "./aircraft/list/aircraft-list.component";
import { FlighDetailComponent } from "./flight/detail/flight-detail.component";
import { FlightListComponent } from "./flight/list/flight-list.component";

export const routes: Routes = [
  { path: "login", component: LoginComponent },
  { path: "register", component: RegisterComponent },
  {
    path: "favorites",
    component: FavoritesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "aircrafts",
    component: AircraftListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "flight",
    component: FlighDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "flights",
    component: FlightListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "bookings",
    component: BookingComponent,
    canActivate: [AuthGuard],
  },
  { path: "**", redirectTo: "bookings" },
];
